var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('router-link',{attrs:{"to":{name: _vm.routes.imagesReportModerated}}},[_vm._v(" Заливка и модерация по ответственным ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }